import { z } from 'zod';

/**
 * Write shape of one category. Array lengths are not constrained here so the API answers
 * `MAINTENANCE_CHECKLIST_COMPOSITION_INVALID` (BR-PRD-154) instead of a generic validation error.
 */
export const MaintenanceChecklistCategoryInputSchema = z.object({
  name: z.string().max(120),
  catalogGenericProductIds: z.array(z.uuid()),
});

export const MaintenanceChecklistItemSchema = z.object({
  catalogGenericProductId: z.uuid(),
  canonicalName: z.string(),
  position: z.number().int().nonnegative(),
});

export const MaintenanceChecklistCategorySchema = z.object({
  name: z.string(),
  position: z.number().int().nonnegative(),
  items: z.array(MaintenanceChecklistItemSchema),
});

export const MaintenanceChecklistResponseSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  name: z.string(),
  categories: z.array(MaintenanceChecklistCategorySchema),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type MaintenanceChecklistCategoryInput = z.infer<
  typeof MaintenanceChecklistCategoryInputSchema
>;
export type MaintenanceChecklistItem = z.infer<typeof MaintenanceChecklistItemSchema>;
export type MaintenanceChecklistCategory = z.infer<typeof MaintenanceChecklistCategorySchema>;
export type MaintenanceChecklistResponse = z.infer<typeof MaintenanceChecklistResponseSchema>;
